import { Component } from '@angular/core';
import { MatomoTrackingService } from '../../services/matomo-tracking.service';

@Component({
  selector: 'app-index',
  standalone: true,
  imports: [],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss',
})
export class IndexComponent {
  constructor(private matomoService: MatomoTrackingService) {}

  ngOnInit(): void {
  }

  onClickPlan(planName: string): void {
    // Track el evento
    this.matomoService.trackEvent('Planes', 'Clic Lo Quiero', planName);

    // Enriquecer el click
    this.matomoService.enrichClick('whatsapp', planName);

    // Redirigir a WhatsApp
    const phone = '582813169200';
    const text = `Hola, estoy interesado en el ${planName}`;
    window.open(
      `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(
        text
      )}&type=phone_number&app_absent=0`,
      '_blank'
    );
  }

  onClickSocialMedia(platform: string): void {
    this.matomoService.enrichClick(platform);
  }
}
